import ImageViewFactory from '../facades/image-view-factory';
import Builder from '../../common/builder/builder';

type Elements = {
  wrapper: HTMLElement;
  image?: HTMLElement;
  loading?: HTMLElement;
  fallback?: HTMLElement;
  error?: HTMLElement;
};

export default class ImageViewBuilder extends Builder<
  Elements,
  ImageViewFactory
> {
  public withImage({ src }: Partial<HTMLImageElement>) {
    this.elements.image = this.factory.createImage({ src });
    this.elements.wrapper?.appendChild(this.elements.image);
    return this;
  }

  public withLoading() {
    this.elements.loading = this.factory.createLoading();
    this.elements.wrapper?.appendChild(this.elements.loading);
    return this;
  }

  public withFallback() {
    this.elements.fallback = this.factory.createFallback();
    this.elements.wrapper?.appendChild(this.elements.fallback);
    return this;
  }

  public withError(error: string) {
    this.elements.error = this.factory.createError(error);
    this.elements.wrapper?.appendChild(this.elements.error);
    return this;
  }
}
